import Chart from '../class/charts/Chart';
import ColumnChart from '../class/charts/ColumnChart';
import Formatter from '../class/Formatter';
import LineChart from '../class/charts/LineChart';
import i18n from 'src/i18n';

const mixinCharts = {
  data() {
    return {
      colorPalette: Chart.getColorPalette(),
      colorPalette1: Chart.getColorPalette1(),
    };
  },

  methods: {
    lines(
      data,
      autoChange = true,
      height = 'auto',
      showBackground = false,
      percent = false
    ) {
      const chartObject = new LineChart(data, height, showBackground, percent);
      const decimal = chartObject.getDataNumbersDecimal();
      const seriesLength = chartObject.getDataSeriesLength(2);

      if (seriesLength[0] == 1 && seriesLength[1] == 1 && autoChange) {
        return this.columns(data, percent, null, height, showBackground);
      } else {
        if (
          seriesLength[0] == 1 &&
          seriesLength[1] > 1 &&
          seriesLength[1] < 8 &&
          autoChange
        ) {
          return this.pieChart(chartObject.toPieConvert(), decimal, true);
        } else {
          return { ...chartObject.lineChartBuild() };
        }
      }
    },

    spline(title_, subtitle_, categories_, series_, showValue_ = false) {
      let chartOptions = {
        chart: {
          zoomType: 'xy',
          type: 'spline',
        },
        title: {
          text: title_ ? title_ : i18n.t('uti.mixin_charts.graphic_title'),
          x: -20,
        },
        subtitle: {
          text: subtitle_
            ? subtitle_
            : i18n.t('uti.mixin_charts.graphic_subtitle'),
          x: -20,
        },
        xAxis: {
          categories: categories_,
        },
        yAxis: [
          {
            labels: {
              format: '{value}%',
              style: {
                color: '#0089C7',
              },
            },
            title: {
              text: i18n.t('uti.mixin_charts.probability_of_rain'),
              style: {
                color: '#0089C7',
              },
            },
            tickAmount: 5,
          },
          {
            labels: {
              format: '{value}\u00B0C',
              style: {
                color: '#DE6C47',
              },
            },
            title: {
              text: i18n.t('uti.mixin_charts.max_temperature'),
              style: {
                color: '#DE6C47',
              },
            },
            min: 0,
            opposite: true,
            tickAmount: 5,
          },
          {
            labels: {
              format: '{value}Km/h',
              style: {
                color: '#6BA652',
              },
            },
            title: {
              text: i18n.t('uti.mixin_charts.wind_speed'),
              style: {
                color: '#6BA652',
              },
            },
            opposite: true,
            tickAmount: 5,
          },
        ],
        tooltip: {
          shared: true,
        },
        plotOptions: {
          spline: {
            //stacking: 'percent',//'normal',
            dataLabels: {
              enabled: showValue_,
              //format: '{point.y:.1f}',
              color: 'black',
              /* style: {
                  textShadow: '0 0 3px black, 0 0 3px black'
              }*/
            },
          },
        },
        series: series_,
      };

      return chartOptions;
    },

    columns(
      data,
      percent = false,
      labelName = null,
      height = 'auto',
      showBackground = false,
      showZeros = false
    ) {
      const chartObject = new ColumnChart(
        data,
        height,
        showBackground,
        percent,
        showZeros
      );

      return { ...chartObject.columnChartBuild(labelName) };
    },

    bars(data_, decimal_, percent_ = false, labelName = null) {
      decimal_ = decimal_ == null ? data_.decimal : decimal_;
      let chartOptions = {
        colors: this.colorPalette1,
        chart: {
          type: 'bar',
          height: data_.height ? data_.height : 'auto',
        },
        title: {
          text: data_.Titulo,
        },
        subtitle: {
          text: data_.STitulo,
        },
        xAxis: {
          categories: data_.xAxis,
          title: {
            text: data_.xAxisT,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: data_.yAxisT,
            align: 'middle',
          },
          labels: {
            align: 'center',
            overflow: 'justify-center',
          },
        },
        tooltip: {
          formatter: function () {
            var value = Formatter.formatMoney(this.y, decimal_);
            return (
              '<span style="font-size: 10px">' +
              this.key +
              '</span><br/>' +
              '<span style="color:' +
              this.series.color +
              '">\u25CF</span> ' +
              (labelName ? labelName : this.series.name) +
              ': <strong>' +
              value +
              (percent_ ? ' %' : '') +
              '</strong><br/>'
            );
          },
          useHTML: true,
          valueSuffix: data_.suffix || '',
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -10,
          y: 30,
          floating: true,
          borderWidth: 1,
          backgroundColor: data_.backgroundColor || '#FFFFFF',
          shadow: true,
        },
        credits: {
          enabled: false,
        },
        series: data_.values,
        exporting: {
          menuItemDefinitions: {
            viewFullscreen: {
              onclick: function () {
                sessionStorage.setItem('esri-fullscreen', 'false');
                this.fullscreen && this.fullscreen.toggle();
              },
            },
          },
        },
      };

      return chartOptions;
    },

    barsWithDrilldown(data_, decimal_, percent_ = false, labelName = null) {
      decimal_ = decimal_ == null ? data_.decimal : decimal_;
      let chartOptions = {
        colors: this.colorPalette1,
        chart: {
          type: 'bar',
          height: data_.height ? data_.height : 'auto',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        title: {
          text: data_.Titulo,
        },
        subtitle: {
          text: data_.STitulo,
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          title: {
            text: data_.yAxisT,
          },
          labels: {
            align: 'center',
          },
        },
        tooltip: {
          formatter: function () {
            var value = Formatter.formatMoney(this.y, decimal_);
            return (
              '<span style="font-size: 10px">' +
              this.key +
              '</span><br/>' +
              '<span style="color:' +
              this.series.color +
              '">\u25CF</span> ' +
              (labelName ? labelName : this.series.name) +
              ': <strong>' +
              value +
              (percent_ ? ' %' : '') +
              '</strong><br/>'
            );
          },
          useHTML: true,
          valueSuffix: data_.suffix || '',
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            states: {
              select: {
                lineWidth: 0,
              },
            },
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          enabled: false,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'bottom',
          x: -25,
          y: -40,
          floating: true,
          borderWidth: 1,
          backgroundColor: data_.backgroundColor || '#FFFFFF',
          shadow: true,
        },
        credits: {
          enabled: false,
        },
        series: data_.values,
        drilldown: {
          ...data_.drilldown,
        },
        exporting: {
          menuItemDefinitions: {
            viewFullscreen: {
              onclick: function () {
                sessionStorage.setItem('esri-fullscreen', 'false');
                this.fullscreen && this.fullscreen.toggle();
              },
            },
          },
        },
      };

      return chartOptions;
    },

    pieChart(
      data_,
      decimal_ = null,
      percent_ = false,
      labelName = null,
      legend = false
    ) {
      decimal_ = decimal_ == null ? data_.decimal : decimal_;
      let chartOptions = {
        colors: this.colorPalette1,
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          type: 'pie',
          height: data_.height ? data_.height : 'auto',
        },
        title: {
          text: data_.Titulo,
        },
        subtitle: {
          text: data_.STitulo,
          x: -20,
        },
        xAxis: {
          categories: data_.xAxis,
        },
        tooltip: {
          pointFormat: `{series.name}: <strong>{point.label:.${decimal_}f}</strong>
            <br/>
            <strong>{point.y:.${decimal_}f}</strong> 
            (<strong>{point.percentage:.${decimal_}f} ${percent_ ? '%' : ''
            }</strong>)`,
        },
        plotOptions: {
          pie: {
            showInLegend: legend,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              color: '#74696b',
              format: `
                <strong> {point.name} </strong>: 
                ${legend
                  ? '<strong>{point.percentage:.1f}%</strong>'
                  : '<strong>{point.label:.f}</strong>'
                }
                <br/>
                <strong> {point.y:.${decimal_}f} </strong>`,
            },
          },
          series: {
            shadow: true,
          },
        },
        legend: {
          enabled: legend,
        },
        series: data_.values,
        drilldown: data_.drilldown ? data_.drilldown : {},
        exporting: {
          menuItemDefinitions: {
            viewFullscreen: {
              onclick: function () {
                sessionStorage.setItem('esri-fullscreen', 'false');
                this.fullscreen && this.fullscreen.toggle();
              },
            },
          },
        },
      };

      return chartOptions;
    },

    combinationChart(data_, decimal_, percent_ = false) {
      let mThis = this;

      let chartOptions = {
        colors: this.colorPalette,
        title: {
          text: data_.Titulo,
        },
        subtitle: {
          text: data_.STitulo,
        },
        xAxis: {
          categories: data_.xAxis,
          crosshair: true,
          labels: {
            style: {
              color: '#6e6e70',
            },
          },
        },
        yAxis: data_.yAxis
          ? data_.yAxis
          : {
            min: 0,
            title: {
              text: data_.yAxisT,
            },
            labels: {
              style: {
                color: '#6e6e70', //,
                //fontWeight: 'bold'
              },
            },
          },
        /*         labels: {
            items: [{
                html: 'Total fruit consumption',
                style: {
                    left: '50px',
                    top: '18px',
                    color: ( // theme
                        Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color
                    ) || 'black'
                }
            }]
        }, */
        tooltip: {
          formatter: function () {
            var value = Formatter.formatMoney(this.y, decimal_);
            return (
              '<span style="font-size: 10px">' +
              this.key +
              '</span><br/>' +
              '<span style="color:' +
              this.series.color +
              '">\u25CF</span> ' +
              this.series.name +
              ': <strong>' +
              value +
              (percent_ ? ' %' : '') +
              '</strong><br/>'
            );
          },
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.05,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              color: 'gray',
              formatter: function () {
                return this.y != 0
                  ? Formatter.formatMoney(this.y, decimal_) +
                  (percent_ ? ' %' : '')
                  : null;
              },
            },
          },
          series: {
            shadow: true,
          },
        },
        series: data_.values,
      };

      return chartOptions;
    },

    formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? '-' : '';

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        let response =
          negativeSign +
          (j ? i.substr(0, j) + thousands : '') +
          i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
          (decimalCount
            ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
            : '');

        return response.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1');
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * Regresa un gráfico Highcharts al nivel raíz de drill-down.
     * @param {String} chartRef – nombre del ref del componente <highcharts>
     * @returns {Boolean} true si se reinició, false si no había gráfico o no había niveles
     */
    resetDrilldown(chartRef) {
      // 1) ¿Existe el componente referenciado?
      var chartComponent = this.$refs[chartRef];
      if (!chartComponent) {
        return false;
      }

      // 2) ¿Existe la instancia Highcharts.Chart?
      var chart = chartComponent.chart;
      if (!chart) {
        return false;
      }

      var didReset = false;

      // 3) Mientras siga en un nivel hijo, subir
      while (chart.drilldownLevels && chart.drilldownLevels.length > 0) {
        chart.drillUp();
        didReset = true;
      }

      // 4) Redibujar por si quedó algo pendiente
      if (didReset && typeof chart.redraw === 'function') {
        chart.redraw();
      }

      return didReset;
    },

    graph(data) {
      let colors = data.colors ? data.colors : Chart.colorPalette;
      let type = data.type ? data.type : 'column';
      let legend = data.legend ? data.legend : { enabled: true };
      let drilldown = data.drilldown ? data.drilldown : [];
      let xAxis = data.xAxis ? data.xAxis : [];
      let yAxis = data.yAxis ? data.yAxis : [];
      let height = data.height ? data.height : '500';
      let chartOptions = {
        colors: colors,
        chart: {
          type: type,
          zoomType: 'xy',
          height: height,
        },
        title: {
          text: data.title
        },
        subtitle: {
          text: data.subtitle
        },
        xAxis: xAxis,
        yAxis: yAxis,
        legend: legend,
        tooltip: data.tooltip,
        plotOptions: data.plotOptions,
        series: data.series,
        drilldown: drilldown
      }
      if (colors.length == 0)
        delete chartOptions.colors;
      return chartOptions;
    },
  },
};

export default mixinCharts;
